export const SOCKET_EVENTS = {
  CHAT_NEW_MESSAGE: 'receive:chat:new_message',
  CHAT_NEW_SCHEDULED_MESSAGE: 'receive:chat:new_scheduled_message',
  CHAT_MESSAGE_READ: 'receive:chat:message_read',
  CHAT_SCHEDULED_MESSAGE_UPDATE: 'receive:chat:scheduled_message_update',
  CHAT_MESSAGE_DELETE: 'receive:chat:message_delete',
  CHAT_SCHEDULED_MESSAGE_DELETE: 'receive:chat:scheduled_message_delete',
  CHAT_MESSAGE_SENT: 'receive:chat:message_sent',
  CHAT_MESSAGE_DELIVERED: 'receive:chat:message_delivered',
  CHAT_SCHEDULED_MESSAGE_SENT: 'receive:chat:scheduled_message_sent',
  CHAT_TOTAL_UNREAD_COUNT: 'receive:chat:total_unread_count',
  CHAT_DELETE: 'receive:chat:chat_delete',
  // CON-1673. An AI reply draft was written into the compose box, or an
  // escalation finished with a research note. Carries { contactId, kind }
  // and no draft text - the page reads the draft through the paths it
  // already uses.
  CHAT_AI_DRAFT_READY: 'receive:chat:ai_draft_ready',
  // CON-2014. A text from a 5-6 digit short code: { shortCode, message }.
  // No contact; it belongs to the Short codes entry, not a contact chat.
  CHAT_SHORT_CODE_MESSAGE: 'receive:chat:short_code_message',
  // CON-XXXX. Activity badges: { serverNow, areas: { smartFormEntries:
  // { total, byEntity } } }. Only ACTIVITY_BADGES holders receive it.
  ACTIVITY_COUNTS: 'receive:activity:counts',
  RATE_LIMITS: 'receive:rate_limits',

  // For namespace /scheduled_messages
  SCHEDULED_MESSAGE_MANUALLY_SENT: 'receive:scheduled_message_manually_sent',
  SCHEDULED_MESSAGE_BIRTHDAY_SENT: 'receive:scheduled_message_birthday_sent',
  SCHEDULED_MESSAGE_SMART_ACTION_SENT: 'receive:scheduled_message_smart_action_sent',
  SCHEDULED_MESSAGE_ORDER_FOLLOW_UP_SENT: 'receive:scheduled_message_order_follow_up_sent',
  SCHEDULED_MESSAGE_CAMPAIGN_SENT: 'receive:scheduled_message_campaign_sent',
  SCHEDULED_MESSAGE_GROUP_SMART_ACTION_SENT: 'receive:scheduled_message_group_sent',
  // END namespace /scheduled_messages
};

// Events the client sends to the server.
export const SOCKET_CLIENT_EVENTS = {
  // CON-XXXX. Sent on connect by ACTIVITY_BADGES holders only; the server
  // answers with ACTIVITY_COUNTS.
  ACTIVITY_COUNTS_REQUEST: 'request:activity:counts',
};

export const TURN_OFF_SOCKETS_ON_THE_SCHEDULED_CONNECTIONS_PAGE = false;
